<template>
  <div class="floating-toolbar">
    <!-- 联系我们按钮 -->
    <div class="toolbar-item" @click="$router.push('/contact')">
      <el-badge :value="1" :max="99" class="badge-item">
        <div class="toolbar-icon contact">
          <el-icon :size="22"><Message /></el-icon>
        </div>
      </el-badge>
      <span class="toolbar-label">{{ $t('floating.contact') }}</span>
    </div>
    
    <!-- 微信按钮 -->
    <div v-if="wechatId" class="toolbar-item" @click="handleWechatClick">
      <div class="toolbar-icon wechat">
        <el-icon :size="22"><ChatDotRound /></el-icon>
      </div>
      <span class="toolbar-label">微信</span>
    </div>
    
    <!-- WhatsApp按钮 -->
    <div v-if="whatsappNumber" class="toolbar-item" @click="handleWhatsappClick">
      <div class="toolbar-icon whatsapp">
        <el-icon :size="22"><Phone /></el-icon>
      </div>
      <span class="toolbar-label">WhatsApp</span>
    </div>
    
    <!-- 返回顶部按钮 -->
    <div class="toolbar-item" @click="scrollToTop">
      <div class="toolbar-icon">
        <el-icon :size="22"><ArrowUp /></el-icon>
      </div>
      <span class="toolbar-label">{{ $t('floating.top') }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Message, ChatDotRound, ArrowUp } from '@element-plus/icons-vue'
import { useCustomerService } from '@/composables/useCustomerService'

const { getWechatContact, getWhatsappContact } = useCustomerService()

// 从客服管理获取联系方式
const wechatId = computed(() => getWechatContact())
const whatsappNumber = computed(() => getWhatsappContact())

// 处理微信点击 - 直接调用微信客户端
const handleWechatClick = () => {
  if (!wechatId.value) return
  // 如果是URL，直接打开
  if (wechatId.value.startsWith('http://') || wechatId.value.startsWith('https://')) {
    window.open(wechatId.value, '_blank')
  } else {
    // 尝试调用微信客户端（weixin://协议）
    window.location.href = `weixin://${wechatId.value}`
    // 如果无法打开，显示提示
    setTimeout(() => {
      alert(`微信号：${wechatId.value}\n\n请复制后在微信中添加好友`)
    }, 500)
  }
}

// 处理WhatsApp点击 - 直接调用WhatsApp客户端
const handleWhatsappClick = () => {
  if (!whatsappNumber.value) return
  // 移除号码中的非数字字符
  const cleanNumber = whatsappNumber.value.replace(/[^0-9]/g, '')
  // 使用wa.me链接，会自动调用WhatsApp客户端
  window.open(`https://wa.me/${cleanNumber}`, '_blank')
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style scoped>
.floating-toolbar {
  position: fixed;
  right: 20px;
  bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 999;
}

.toolbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.toolbar-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: var(--color-primary);
  color: var(--color-white);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
}

.toolbar-icon.contact {
  background-color: var(--color-primary);
}

.toolbar-icon.wechat {
  background-color: #07C160; /* 微信绿色 */
}

.toolbar-icon.whatsapp {
  background-color: #25D366; /* WhatsApp绿色 */
}

.toolbar-item:hover .toolbar-icon {
  transform: scale(1.1);
  box-shadow: var(--shadow-lg);
}

.toolbar-label {
  font-size: 11px;
  color: var(--color-text-secondary);
  background: var(--color-white);
  padding: 2px 8px;
  border-radius: 10px;
  box-shadow: var(--shadow-sm);
}
</style>
